<template lang="html">
	<div class="inner-modal">
		<div class="head-modal row">
			<div class="left">
				<div class="head-modal-title">
					Nouveau message
				</div>
				<div class="head-modal-emphase">
					Commencez une discussion avec votre {{ (data.isAdvisor) ? 'client' : 'patrimofficer' }}
				</div>
			</div>
		</div>
		<div class="body-modal">
			<form class="form-ui column default-form-ui need-big">
				<div class="form-elem-container">
					<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('title')}">
						<label for="title">Titre</label>
						<input v-validate="'required'" type="text" name="title" v-model="title">
					</div>
					<div v-if="errors.has('title')" class="error-message">{{ errors.first('title') }}</div>
				</div>
				<div class="form-elem-container in-modal">
					<div class="ctn-textarea ctn-label" v-inputUI :class="{error: errors.has('body')}">
						<label for="body">Message</label>
						<textarea v-validate="'required'" type="text" name="body" v-model="body"></textarea>
					</div>
					<div v-if="errors.has('body')" class="error-message">{{ errors.first('body') }}</div>
				</div>
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="close">Annuler</div>
					<div class="btn btn-red" @click="send">Envoyer</div>
				</div>
			</form>
		</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomSelect from '@/common/components/Form/CustomSelect'

export default {
	name: 'newMessage',
	props: ['data'],
	components: {
		CustomSelect
	},
	data () {
		return {
			title: null,
			body: null
		}
	},
	mounted () {
		console.log(this.data)
	},
	methods: {
		close () {
			this.$emit('close')
		},
		send () {
			this.$store.dispatch('newThread', {
				request: {
					title: this.title,
					body: this.body,
					user_id: this.data.id
				},
				user: {
					id: this.user.id,
					first_name: this.user.firstname,
					last_name: this.user.lastname
				}
			}).then(() => {
				this.close()
			}).catch((error) => {
				console.warn(error)
			})
		}
	},
	computed: {
		...mapGetters({
			user: 'user'
		})
	}
}
</script>

<style lang="scss" scoped>

	.head-modal {
		justify-content: flex-start;
	}

	.body-modal {
		padding-top: 0.5rem!important;

		form {
			align-items: flex-start;
			.form-elem-container {
				width: 100%;
			}
		}
	}

	.custom-select {
		width: 200px;
	}
</style>



// WEBPACK FOOTER //
// NewThread.vue?c57af3a6